import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { buyerAddSchema } from "../../../ValidationSchema";
import ReactSelect from "../../../Components/PortalSelect";

// import ReactSelect from "react-select";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    border: "1px solid #bfc9d4",
    boxShadow: "#000 !important",
    borderRadius: "6px",
    padding: "4px",
    "&:hover": {
      border: "1px solid #bfc9d4",
    },
  }),
  multiValue: (styles) => {
    return {
      ...styles,
      backgroundColor: "#606060",
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: "#000",
    "& > svg": {
      backgroundColor: "#fff",
      borderRadius: "10px",
      marginLeft: "2px",
      marginRight: "2px",
    },
    ":hover": {
      backgroundColor: data.color,
      color: data.color,
    },
  }),
  option: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: "white",
      color: "#000",
      ":hover": {
        backgroundColor: "#f5f5f5",
      },
    };
  },
};

const LeadAdd = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const Navigate = useNavigate();
  const [initialValues] = useState({
    product_id: "",
    size: "",
    quantity: "",
    category: "",
    burst_factor: [],
    material_color: [],
    print_coverage: [],
    title: "",
    media_file: null,
  });

  const [categoryData, setCategoryData] = useState([]);

  const [showProductList, setShowProductList] = useState(false);
  const [categoryId, setCategoryId] = useState(null);

  const [products, setProducts] = useState([]);
  const [title, setTitle] = useState("");

  const ProductData = () => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/category-products?category_id=${categoryId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        if (
          res &&
          res?.data &&
          res?.data?.data &&
          Array.isArray(res?.data?.data)
        ) {
          setProducts(
            res?.data?.data?.map((item) => ({
              label: item?.title || "Untitled",
              value: item?.id,
            }))
          );
        } else {
          console.warn("Unexpected API response:", res);
          setProducts([]); // Optional: set empty state
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        if (err.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  useEffect(() => {
    if (categoryId != null) {
      ProductData();
    }
  }, [categoryId]);

  const CategoriesData = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/admin/categories/get`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setCategoryData(
          res?.data?.data?.docs?.map((item) => {
            return {
              label: item?.name || "Untitled", // fallback if title is undefined
              value: item?.id,
            };
          })
        );
      })
      .catch((err) => {
        if (err.response.data.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const [mediaFiles, setMediaFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileChange = (e) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      setMediaFiles(Array.from(e.target.files));
      setSelectedFiles(files);
    }
  };

  const BuyerAdd = useFormik({
    initialValues,
    // validationSchema: buyerAddSchema,

    onSubmit: (values, action) => {
      // Reset form after submission
      action.resetForm();

      const formData = new FormData();
      // Append all form values to FormData
      // Object.keys(values).forEach((key) => {
      //   if (Array.isArray(values[key])) {
      //     // If it's an array, join it into a comma-separated string
      //     formData.append(key, values[key].join(","));
      //   } else {
      //     formData.append(key, values[key]);
      //   }
      // });
      // Append media files to FormData
      mediaFiles.forEach((file) => {
        formData.append("media_file", file);
      });
      // Append title separately
      formData.append("title", values.title || title);
      formData.append("category", values.category);
      formData.append("product_id", values.product_id);
      formData.append("size", values.size);
      formData.append("quantity", values.quantity);
      formData.append("burst_factor", values.burst_factor.join(","));
      formData.append("material_color", values.material_color.join(","));
      formData.append("print_coverage", values.print_coverage.join(","));

      // Convert specific array fields to comma-separated strings
      // const payload = {
      //   ...values,
      //   burst_factor: Array.isArray(values.burst_factor)
      //     ? values.burst_factor.join(",")
      //     : values.burst_factor,
      //   material_color: Array.isArray(values.material_color)
      //     ? values.material_color.join(",")
      //     : values.material_color,
      //   print_coverage: Array.isArray(values.print_coverage)
      //     ? values.print_coverage.join(",")
      //     : values.print_coverage,
      //   title: title,
      // };

      axios
        .post(
          `${process.env.REACT_APP_URL}/admin/supplier-buy-lead-add`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            toast.success(`${res?.data?.message}`);

            if (user.user_type === "supplier") {
              Navigate("/admin/outbound", { state: res.data.msg });
            } else {
              Navigate("/admin/supplier-by-lead/list", { state: res.data.msg });
            }
          }
        })
        .catch((err) => {
          console.error("Submission Error:", err);

          toast.error(err.response?.data?.message || "Something went wrong");
        });
    },
  });

  useEffect(() => {
    CategoriesData();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="al-head">
        <div>
          <h1 className="al-title">Lead Add</h1>
          <p className="al-sub">Add a new lead.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

        <div className="al-card">
          <div>
            <form onSubmit={BuyerAdd.handleSubmit}>
              <div className="row">
                {/* Column 1 */}

                <div className="col-md-6 mb-3">
                  <label className="al-label">
                    Category
                  </label>
                  <ReactSelect
                    options={categoryData}
                    isClearable={false}
                    styles={colourStyles}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    placeholder="Select Category"
                    name="category"
                    onChange={(e) => {
                      setCategoryId(e?.value); // set in component state
                      BuyerAdd?.setFieldValue("category", e?.value); // set in Formik
                    }}
                    value={
                      categoryData.find(
                        (item) => item.value === BuyerAdd.values.category
                      ) || null
                    }
                  />

                  {BuyerAdd?.errors?.category &&
                    BuyerAdd?.touched?.category && (
                      <h6 className="text-danger mt-2 ml-1">
                        {BuyerAdd?.errors?.category}
                      </h6>
                    )}
                </div>

                {/* Column 2 */}
                <div className="col-md-6 mb-3">
                  <label className="al-label">
                    Product Name
                  </label>
                  <ReactSelect
                    options={products}
                    isClearable={false}
                    styles={colourStyles}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    placeholder="Select Product"
                    name="product_id"
                    onChange={(e) => {
                      setTitle(e?.label);
                      BuyerAdd?.setFieldValue("product_id", e?.value);
                    }}
                    value={
                      products.find(
                        (item) => item.value === BuyerAdd.values.product_id
                      ) || null
                    }
                  />

                  {BuyerAdd?.errors?.product && BuyerAdd?.touched?.product && (
                    <h6 className="text-danger mt-2 ml-1">
                      {BuyerAdd?.errors?.product}
                    </h6>
                  )}
                </div>

                <div className="col-md-6 mb-3">
                  <label className="al-label">
                    Size
                  </label>
                  <input
                    className="al-input"
                    type="text"
                    placeholder="Enter Size"
                    value={BuyerAdd.values.size}
                    onChange={BuyerAdd.handleChange}
                    onBlur={BuyerAdd.handleBlur}
                    name="size"
                  />
                  {BuyerAdd.errors.size && BuyerAdd.touched.size && (
                    <h6 className="text-danger mt-2 ml-1">
                      {BuyerAdd.errors.size}
                    </h6>
                  )}
                </div>

                <div className="col-md-6 mb-3">
                  <label className="al-label">
                    Quantity
                  </label>
                  <input
                    className="al-input"
                    type="text"
                    placeholder="Enter Quantity"
                    value={BuyerAdd.values.quantity}
                    onChange={BuyerAdd.handleChange}
                    onBlur={BuyerAdd.handleBlur}
                    name="quantity"
                  />
                  {BuyerAdd.errors.quantity && BuyerAdd.touched.quantity && (
                    <h6 className="text-danger mt-2 ml-1">
                      {BuyerAdd.errors.quantity}
                    </h6>
                  )}
                </div>

                <div className="col-md-6 mb-3">
                  <label className="al-label">
                    Material Color
                  </label>
                  <ReactSelect
                    isMulti
                    options={[
                      { label: "White Duplex", value: "White Duplex" },
                      { label: "Brown Kraft", value: "Brown Kraft" },
                      { label: "Art Paper", value: "Art Paper" },
                    ]}
                    isClearable={false}
                    styles={colourStyles}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    placeholder="Select Material Color"
                    name="material_color"
                    onChange={(selectedOptions) =>
                      BuyerAdd.setFieldValue(
                        "material_color",
                        selectedOptions?.map((option) => option.value) || []
                      )
                    }
                    // 🧠 Optional: Set default value in edit mode
                    value={
                      BuyerAdd.values.material_color?.map((val) => ({
                        label: val,
                        value: val,
                      })) || []
                    }
                  />
                  {BuyerAdd?.errors?.material_color &&
                    BuyerAdd?.touched?.material_color && (
                      <h6 className="text-danger mt-2 ml-1">
                        {BuyerAdd?.errors?.material_color}
                      </h6>
                    )}
                </div>
                <div className="col-md-6 mb-3">
                  <label className="al-label">
                    Print Coverage
                  </label>
                  <ReactSelect
                    isMulti
                    options={[
                      { label: "Single", value: "Single" },
                      { label: "Multi", value: "Multi" },
                      { label: "No print", value: "No print" },
                    ]}
                    isClearable={false}
                    styles={colourStyles}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    placeholder="Select Print Coverage"
                    name="print_coverage"
                    // ✅ Convert selected options to array of values
                    onChange={(selectedOptions) =>
                      BuyerAdd.setFieldValue(
                        "print_coverage",
                        selectedOptions?.map((option) => option.value) || []
                      )
                    }
                    // ✅ Optional: for edit mode / default selected values
                    value={
                      BuyerAdd.values.print_coverage?.map((val) => ({
                        label: val,
                        value: val,
                      })) || []
                    }
                  />
                  {BuyerAdd?.errors?.print_coverage &&
                    BuyerAdd?.touched?.print_coverage && (
                      <h6 className="text-danger mt-2 ml-1">
                        {BuyerAdd?.errors?.print_coverage}
                      </h6>
                    )}
                </div>

                <div className="col-md-6 mb-3">
                  <label className="al-label">
                    Burst Factor
                  </label>
                  <ReactSelect
                    isMulti
                    options={[
                      { label: "18", value: "18" },
                      { label: "20", value: "20" },
                      { label: "22", value: "22" },
                      { label: "24", value: "24" },
                      { label: "28", value: "28" },
                      { label: "35", value: "35" },
                      { label: "40", value: "40" },
                    ]}
                    isClearable={false}
                    styles={colourStyles}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    placeholder="Select Burst Factor"
                    name="burst_factor"
                    // ✅ Convert selected options to values array for Formik
                    onChange={(selectedOptions) =>
                      BuyerAdd.setFieldValue(
                        "burst_factor",
                        selectedOptions?.map((option) => option.value) || []
                      )
                    }
                    // ✅ For showing selected values
                    value={
                      BuyerAdd.values.burst_factor?.map((val) => ({
                        label: val,
                        value: val,
                      })) || []
                    }
                  />
                  {BuyerAdd?.errors?.burst_factor &&
                    BuyerAdd?.touched?.burst_factor && (
                      <h6 className="text-danger mt-2 ml-1">
                        {BuyerAdd.errors.burst_factor}
                      </h6>
                    )}
                </div>
                <div className="col-md-6 mb-3">
                  <label className="al-label">
                    Media File
                  </label>
                  <input
                    type="file"
                    multiple
                    accept="image/*,.pdf"
                    onChange={handleFileChange}
                    className="al-input al-input--file"
                  />
                  {/* {selectedFiles.length > 0 && (
                    <div className="mt-2">
                      <div className="flex flex-nowrap gap-4 overflow-x-auto">
                        {selectedFiles.map((file, index) => {
                          const fileURL = URL.createObjectURL(file);
                          const isImage = file.type.startsWith("image/");
                          return (
                            <div key={index}>
                              {isImage ? (
                                <img
                                  src={fileURL}
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                  }}
                                />
                              ) : (
                                <p className="text-sm text-gray-700 truncate">
                                  {file.name}
                                </p>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )} */}

                  {selectedFiles && selectedFiles.length > 0 && (
                    <div className="mt-2 ">
                      {selectedFiles.map((file, index) => {
                        const fileURL = URL.createObjectURL(file);
                        const isImage = file.type.startsWith("image/");
                        return (
                          <div key={index}>
                            {isImage ? (
                              <img
                                src={fileURL}
                                alt={`preview-${index}`}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                }}
                              />
                            ) : (
                              <p className="text-sm text-gray-700 truncate">
                                {file.name}
                              </p>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              <div className="al-actionbar">
                <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
                <button className="al-btn al-btn--primary" type="submit">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                  Create Lead
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* 
          {showProductList && (
                <div className="mt-4">
                  <h5 className="mb-3">Product List</h5>
                  <div className="row">
                    {products.map((product) => (
                      <div key={product.id} className="col-md-3 col-sm-6 mb-4">
                        <div className="card shadow">
                          <img
                           src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${product?.product_image}`}
                            alt={product.title}
                            className="card-img-top"
                            style={{ height: "180px", objectFit: "cover" }}
                          />
                          <div className="card-body">
                            <h6 className="card-title mb-0">{product.title}</h6>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )} */}
    </div>
  );
};

export default LeadAdd;
